import { Operation } from 'urql';
import { OperationDefinitionNode } from 'graphql/language';

export const getQueryName = (operation: Operation) => {
	const operationDefinition = operation?.query?.definitions?.find(
		(def) => def?.kind === 'OperationDefinition'
	) as OperationDefinitionNode;

	return operationDefinition?.name?.value;
};

export interface GraphQLBusinessError {
	message: string;
	__typename: string;
}
